var collapsible_list_pair_rtlignore_default = {
  "container": "PRVDc",
  "title": "i2H-d",
  "viewerContainer": "TIeF8",
  "titleContainer": "EHTae",
  "content": "gYCTR",
  "expandIcon": "NQNhe",
  "dndIcon": "czHoe",
  "RTL": "CHJ61",
  "LTR": "qBL1g",
  "itemContainer": "t8r8W",
  "itemContainerViewer": "o8DgI",
  "mouseDown": "B4ZR5",
  "innerEditor": "OkD6t",
  "item": "DlQ8V",
  "floatingAddPluginMenuWrapper": "omFsP"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
